import React from 'react'
import { v4 as uuid } from 'uuid';
import Helmet from 'react-helmet';

import { partnerMerchants } from './constants';
import '../../../public/css/media/_uk-shopping.scss';
import { netcoreScript } from '../../utils/utils';

const metadata = "Shop from your favorite online stores in the UK & have your items shipped to the Philippines. Sign up at ShippingCart today.";
const name = "Shop from UK Online stores & Ship to the Philippines | ShippingCart";

const createReactClass = require('create-react-class');

const UKShopping = createReactClass({
  componentDidMount() {
    document.getElementById('chck1').checked = true
    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->
  },

  renderMerchantLogos(category){
    return (
      partnerMerchants[category].map(({ logo, link, alt }) => (
        <div key={uuid()} className="logo-store">
          <a href={link} target="_blank" rel="noopener noreferrer">
            <img src={logo} alt={alt} />
          </a>
        </div>
      ))
    )
  },

  render() {
    return (
      <div>
        <Helmet>
          <meta name="description" content={metadata} data-react-helmet="true" />
          <title>{name}</title>
        </Helmet>
        <section id="sc-smartbar">
          <div className="sc-smartbar" id="smartbar-close">
            <div className="box-container">
              <p><span>SIGN UP AND SHIP NOW:</span> Use code <span>20NEWSC</span> to get 20% OFF on Air shipment.
                    New customers only.</p>
            </div>
            <div className="xbtn">
              <button type="button" onclick="document.getElementById('smartbar-close').style.display='none'" className="close"><span>×</span></button>
            </div>
          </div>
        </section>
        <section>
        <div className="container row1-cols2-layout">
          <div className="content">
            <h1 className="headers">Buy from UK Online Shopping Sites and Ship to the Philippines</h1>
            
            <div className="wrapper-content">
              <div className="cols cols-1">
                  <img src="https://cdn.shippingcart.com/assets/shop-in-uk-img-20200602030840.png" alt="shop-in-us" height="400" width="400" />
              </div>
              <div className="cols cols-2">
                  <p>
                    Love UK online shopping? Shipping your orders just got easier with ShippingCart. Whether you want to buy from eBay or shop for the latest clothes and fashion at ASOS, shipping to the Philippines is faster and more affordable with us!
                  </p>
                  <p>
                    <strong>How to Shop, Ship, and Save Smart with ShippingCart</strong>
                  </p>
                  <ol className="uk-ordered-list">
                    <li>Sign up for free today to receive your UK shipping address. </li>
                    <li>Shop from your favorite UK stores and check out using your ShippingCart UK address.</li>
                    <li>
                    Consolidate your packages into one shipment to save up to 70% on shipping fees. 
                    </li>
                    <li>Select a shipping method, pay, and wait for your package.</li>
                  </ol>
                  <p>
                  With ShippingCart, you can buy from Amazon UK and ship to the Philippines at competitive delivery rates. You can also shop from other beloved brands that offer bags, clothes, shoes, electronics, toys, and many more. 
                  </p>
              </div>
          </div>
          </div>
        </div>
        </section>
        <section className="odd">
          <div className="container logos">
  
            {/* <div className="content"> */}
  
            <div className="container-static">
  
  
  
              <h1 className="header">Top Picks</h1>
              <div className="logo-stores">
                {this.renderMerchantLogos('topPicks')}
              </div>
  
            </div>
  
          </div>
          {/* </div> */}
  
  
        </section>
  
  
        <section>
          <div className="container logos">
            <div className="content">
              <h1 className="header">Fashion and Beauty</h1>
              <div className="logo-stores">
                {this.renderMerchantLogos('fashionBeauty')}
              </div>
            </div>
          </div>
        </section>
        <section className="odd">
          <div className="container logos">
            <div className="content">
              <h1 className="header">Home</h1>
              <div className="logo-stores">
                {this.renderMerchantLogos('home')}
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container logos">
            <div className="content">
              <h1 className="header">Tech</h1>
              <div className="logo-stores">
                {this.renderMerchantLogos('tech')}
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container hero seo-element">
            <div className="content seo-element">
              <div className="seo-content">
                <h1 className="header">FREQUENTLY ASKED QUESTIONS</h1>
                <div className="row">
                  <div className="col">
                    <div className="tabs">
                      <div className="tab">
                        <input type="checkbox" id="chck1" value="on" />
                        <label className="tab-label" htmlFor="chck1">How does package consolidation work?</label>
                        <div className="tab-content">
                          <p>
                            Shipping multiple packages direct from UK online shopping stores is costly. With ShippingCart's consolidation service, our expert packers can combine your orders from different stores into a single shipment, helping you save on international shipping fees.
                          </p>
                          <p>Here’s how it works:</p>
                          <ol className="chck1">
                            <li>Sign up for a free account on ShippingCart and we’ll give you our UK shipping address.</li>
                            <li>Shop from different UK online shopping stores and use the UK address at checkout.</li>
                            <li>Wait for all your orders to arrive. We provide free storage for up to 30 days.</li>
                            <li>Once all your orders have arrived at our hub, select your preferred shipping method to the Philippines, and then pay.</li>
                            <li>Get excited while waiting for your package!</li>
                          </ol>
                          <p>
                            We will always try to consolidate your purchases from different UK online shopping sites into one shipment unless you specify otherwise. Also, it's best to choose a single shipment method for your consolidated items as we charge separately for air and sea cargo.
                          </p>
                        </div>
                      </div>
                      <div className="tab">
                        <input type="checkbox" id="chck2" />
                        <label className="tab-label" htmlFor="chck2">Which UK stores can I shop from?</label>
                        <div className="tab-content">
                          <p>
                            UK online shopping stores are available to everyone in the Philippines -- including you! You can shop these popular online stores in the UK from the comfort of your home:
                          </p>
                          <ul className="chck2">
                            <li>Amazon UK
                            <p>Amazon UK is one of the most popular destinations for UK online shopping. As the number one destination for online shopping in the UK, you can purchase everything from high-end electronics and antique furniture to rare comic books and Funko pops you won’t find anywhere in the Philippines.</p>
                            </li>
                            <li>eBay
                            <p>eBay is the ultimate UK online shopping destination for everyday items, toys, books, furniture pieces, sports items, health supplements, collectables, and more! </p>
                            </li>
                            <li>ASOS
                            <p>When it comes to UK online shopping stores, this online store brings you the freshest clothing, accessories, shoes, and gifts to express your individuality. Aside from their roster of in-house brands, ASOS also has a slick range of fashion labels you won't find anywhere else, making it a unique fashion destination when you’re shopping online in the UK.</p>
                            </li>
                            <li>Argos
                            <p>If you're shopping online in the UK for household and department store items, Argos is the site to be. As a premier UK online shopping destination, they have something you and your entire family will love, including products from top brands like Nespresso, LEGO, Bose, Beats, Samsung, Dyson, and exclusive lines like Chad Valley.</p>
                            </li>
                            <li>Next
                            <p>Next is an in-house label of high-end women's, men's, and children's clothing -- along with accessories and housewares. While they have several physical stores, their site is a popular online shopping destination in the UK. </p>
                            </li>
                            <li>Zagg
                            <p>If you're looking for high-end technologies, ZAGG is your go-to online shopping store in the UK. Their award-winning product selection includes screen protection, mobile keyboards, power management solutions, phone cases, and personal audio.</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="tab">
                        <input type="checkbox" id="chck3" />
                        <label className="tab-label" htmlFor="chck3">How long does it take to ship to the Philippines?</label>
                        <div className="tab-content">
                          <p>Once your orders have been shipped to our UK address, estimated time of arrival from our hub to the PH depends on your chosen shipment method. For instance, your items can arrive in as fast as 10 days via air cargo. If you prefer a more budget-friendly option, we offer shipping via sea cargo that takes up to 45 days.</p>
                        </div>
                      </div>
                      <div className="tab">
                        <input type="checkbox" id="chck4" />
                        <label className="tab-label" htmlFor="chck4">How much does it cost to ship items from the UK to the Philippines?</label>
                        <div className="tab-content">
                          <p>Find out how competitive our rates are with our shipping fee estimator. It will calculate the total costs of your shipment based on the information you provide. It's quick, easy, and free!</p>
                        </div>
                      </div>
                      <div className="tab">
                        <input type="checkbox" id="chck5" />
                        <label className="tab-label" htmlFor="chck5">How do I track my orders?</label>
                        <div className="tab-content">
                          <p>The online store you ordered from (e.g. Amazon or eBay) should give you the tracking number of your package so you can monitor it while it's on transit to the ShippingCart warehouse. If you don't have the tracking number, contact the online store and ask for it. After your package has arrived at our warehouse, we will send you an email notice. If you have the ShippingCart mobile app installed, you can receive push notifications about the status of your package.</p>
                          <p>Once your shipment is on the way to the Philippines, we'll notify you via email or push notifications, and give you a tracking number so you can constantly check on the status of your package. Our chat support is also available every day from 10:00 a.m. to 7:00 p.m. (UTC+08:00) except holidays for any concerns or inquiries.</p>
                          <p>With ShippingCart, the process of buying from UK online shopping stores is simple and easy. Convenient tools and reliable delivery service from the UK to your door -- that's our promise to you.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
})

export default UKShopping;


/** WEBPACK FOOTER **
 ** ./src/components/UKShopping/UKShopping.js
 **/